module.exports = __webpack_public_path__ + "static/media/connectino-logo-en.9eb792c1.svg";